import axios from 'axios';

const createFormData = (values) => {
  const formData = new FormData();

  Object.entries(values).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return formData;
};

export const uploadFile = ({
  values,
  uploadEndpoint,
  csrfToken,
  onResponse = () => {},
  onError = () => {},
}) => {
  const formData = createFormData(values);
  axios
    .post(uploadEndpoint, formData, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'multipart/form-data',
        'X-CSRFToken': csrfToken,
      },
    })
    .then(onResponse)
    .catch(onError);
};
